import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { appointmentQKeys } from "@hooks/queries/appointment/queryKeys";
import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { scheduleQKeys } from "@hooks/queries/schedule/queryKeys";


interface MutationProps {
  appointmentId: string;
  cancellationReason?: string;
}

export const useCancelAppointment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ appointmentId, cancellationReason }: MutationProps) => {
      return api.patch(`appointments/${appointmentId}/cancel`, { cancellation_reason: cancellationReason });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.all() });
      queryClient.invalidateQueries({ queryKey: consultationQKeys.all() });
      queryClient.invalidateQueries({ queryKey: scheduleQKeys.all() });
    },

    onError: (res: any) => {
      console.error("[From Cancel Appointment]", res);
      queryClient.invalidateQueries({ queryKey: appointmentQKeys.all() });
      queryClient.invalidateQueries({ queryKey: scheduleQKeys.all() });
    },
  });
};
